import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

/** twreact-ui blocks render links as `<linkAs href>`; react-router's Link wants `to`. */
const RouterLink = forwardRef(function RouterLink({ href, ...props }, ref) {
  return <Link ref={ref} to={href} {...props} />;
});

export default RouterLink;
